// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IAuctionSchema } from '../auction/AuctionSchema';
import type { IOfferServicesSchema } from '../offer_services/OfferServicesSchema';

export interface IOfferExtendedPropertiesSchema {
  /** Данные аукциона **/
  auction?: IAuctionSchema;
  /** Находится ли объявка в избранном у текущего пользователя **/
  isFavorite: boolean;
  /** Плашки **/
  labels: ELabels[];
  /** Сервисы объявления пользователя на странице выдачи, ниже текущего объявления **/
  offerServices?: IOfferServicesSchema;
}
export enum ELabels {
  /** Доступна геоаналитика от BestPlace **/
  'BestPlaceAnalytics' = 'bestPlaceAnalytics',
  /** Электронные торги в коммерции **/
  'CommEsales' = 'commEsales',
  /** Это выгодно **/
  'CoworkingBenefits' = 'coworkingBenefits',
  /** "Электронные торги **/
  'ElectronTradeSite' = 'electronTradeSite',
  /** От собственника **/
  'FromOwner' = 'fromOwner',
  /** Хорошая цена **/
  'GoodPrice' = 'goodPrice',
  /** Залоговая недвижимость **/
  'PledgeRealty' = 'pledgeRealty',
  /** Объект размещён на открытом аукционе **/
  'TradeRealty' = 'tradeRealty',
  /** Уникально на Циан **/
  'UniqueForCian' = 'uniqueForCian',
}
